import { render, staticRenderFns } from "./RelatorioRetornouOrigem.vue?vue&type=template&id=6ab30a15"
import script from "./RelatorioRetornouOrigem.vue?vue&type=script&lang=js"
export * from "./RelatorioRetornouOrigem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports